import { render, staticRenderFns } from "./largerScreen.vue?vue&type=template&id=52a28916"
import script from "./largerScreen.vue?vue&type=script&lang=js"
export * from "./largerScreen.vue?vue&type=script&lang=js"
import style0 from "./largerScreen.vue?vue&type=style&index=0&id=52a28916&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports